<template>
  <div @mouseleave="mouseleave" class="relative h-full">
    <!-- 一级菜单选项 -->
    <div
      class="flex h-full bg-hex-$portalPrimaryColor text-hex-$portalPrimaryTextColor  font-400 text-18px w-full"
      ref="nav"
    >
      <div
        v-for="(item, index) in navList"
        :key="index"
        class="flex-1 cursor-pointer h-full text-center leading-50px"
      >
        <span
          @click="navbarClick(item)"
          class="relative"
          @mouseenter="mouseenter(item, index)"
          :class="{
            active: currentNav === item.id,
          }"
          :title="item.name"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
    <!-- 二级菜单选项 -->
    <div
      v-show="subNavbarVisible"
      class="absolute top-48px z-2 w-full font-400 text-16px border-b-1px border-x-1px border-hex-e6e6e6 text-hex-333 bg-hex-fff"
      ref="subNav"
    >
      <div class="w-full h-full pt-20px leading-20px overflow-hidden flex flex-wrap">
        <div
          v-for="(child, index) in subNavbarChildren"
          :key="index"
          class="!w-1/4 h-full px-20px pb-20px text-18px text-center cursor-pointer sub-nav-item"
          :class="{
            'text-hex-$portalPrimaryColor': subNavbar === child.id,
          }"
          @click="subNavbarClick(child)"
          :title="child.name"
        >
          {{ child.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench-std'

const columnApi = new ColumApi()
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mode: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      subNavbarVisible: false, // 二级导航栏菜单box, 显示二级菜单的
      navbar: {},
      subNavbarChildren: [],
      subNavbar: {}, // 当前二级菜单子项
      columnData: [],
      currentNav: '',
      translateX: 0,
      navList: [],
    }
  },
  computed: {
    // navList() {
    //   if (!this.data?.columnIds) return []
    //   const list = []
    //   _.forEach(this.data.columnIds, (item) => {
    //     const column = _.find(this.columnData, { id: item })
    //     if (column) {
    //       list.push(column)
    //     }
    //   })
    //   return list
    // },
    columnId() {
      return this.$route.query.columnId
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      async handler(val, oldVal) {
        if (!_.isEqual(val?.columnIds, oldVal?.columnIds)) {
          this.navList = await this.getNavList()
        }
      },
    },
    columnId: {
      immediate: true,
      handler(val) {
        this.currentNav = val
      },
    },
  },
  methods: {
    async getNavList() {
      if (this.columnData.length === 0) {
        await this.getColumnData()
      }
      if (!this.data?.columnIds) return []
      const list = []
      _.forEach(this.data.columnIds, (item) => {
        const column = _.find(this.columnData, { id: item })
        if (column) {
          list.push(column)
        }
      })
      return list
    },
    mouseenter(navbar, index) {
      this.navbar = navbar
      if (navbar.child) {
        this.subNavbarChildren = navbar.child.slice(0, 9)
        this.subNavbarVisible = true
        // 存在children 才显示一级标题和二级标题
        // this.$nextTick(() => {
        //   const subNavWidth = this.$refs.subNav.offsetWidth
        //   const subItemWidth = subNavWidth / 9
        //   const navWidth = this.$refs.nav.offsetWidth
        //   const navItemWidth = navWidth / this.navList.length
        //   const subWidth = subItemWidth * this.subNavbarChildren.length
        //   const offsetWidth = navItemWidth * index - subWidth / 2 + navItemWidth / 2
        //   if (offsetWidth < 0) {
        //     this.translateX = 0
        //   } else if (subWidth + offsetWidth > subNavWidth) {
        //     this.translateX = subNavWidth - subWidth
        //   } else {
        //     this.translateX = offsetWidth
        //   }
        // })
        return
      }
      this.subNavbarVisible = false
      this.subNavbarChildren = []
    },
    mouseleave() {
      this.subNavbarVisible = false
    },
    // 一级navbar-click
    navbarClick(navbar) {
      if (this.mode === 'update' || !navbar.existPage) return
      this.currentNav = navbar.id
      // this.$router.push({
      //   path: '/portal/homepage',
      //   query: {
      //     columnId: navbar.id,
      //   },
      // })
      window.open(
        `${window.location.origin}${window.location.hash ? '/#' : ''}${
          this.routerBase
        }/integration/portal/homepage?columnId=${navbar.id}`
      )
    },
    // 二级sub-navbar-click
    subNavbarClick(subNavbar) {
      if (this.mode === 'update' || !subNavbar.existPage) return
      this.subNavbar = subNavbar.id
      // this.$router.push({
      //   path: '/portal/homepage',
      //   query: {
      //     columnId: subNavbar.id,
      //   },
      // })
      window.open(
        `${window.location.origin}${window.location.hash ? '/#' : ''}${
          this.routerBase
        }/integration/portal/homepage?columnId=${subNavbar.id}`
      )
    },
    async getColumnData() {
      const [err, res] = await columnApi.tree(0, {
        isExistPage: true,
      })
      if (!err) {
        this.columnData = res
      }
    },
  },
}
</script>
<style scoped lang="scss">
.active {
  font-weight: 700;
  &::before {
    content: '';
    position: absolute;
    // width: 40px;
    width: 100%;
    // transform: translate(50%, 0);
    height: 3px;
    background-color: var(--portalPrimaryTextColor);
    bottom: -7px;
  }
}
.sub-nav-item {
  &:hover {
    color: var(--portalPrimaryColor);
  }
}
</style>
